import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "../lib/api";

const ContentContext = createContext();
export const useContent = () => useContext(ContentContext);

export function ContentProvider({ children }) {
  const [content, setContent] = useState(null);

  const load = useCallback(async () => {
    const { data } = await api.get("/content");
    setContent(data);
    return data;
  }, []);

  useEffect(() => { load(); }, [load]);

  const save = async (next) => {
    const { data } = await api.put("/content", next);
    setContent(data);
    return data;
  };

  return (
    <ContentContext.Provider value={{ content, setContent, load, save }}>
      {children}
    </ContentContext.Provider>
  );
}
